import { createSelector } from '@reduxjs/toolkit'

import { TAppStore } from '~/src/Configurations/AppStore'

import { TAppVersion } from '~/src/Entities/App/App.Types'

export const SLICE_NAME = 'appConfig'

const select = (state: TAppStore) => state[SLICE_NAME]

export const getAppConfigReducer = select

export const getAppVersion = createSelector(
  select,
  appConfig => appConfig.appVersion as TAppVersion
)
